import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import DixuHead from "../../components/DixuHead/DixuHead";
import DixuRegisterFlow from "../../components/DixuRegisterFlow/DixuRegisterFlow";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';
import { getUser, redirect } from "../../services/ApiService";
const Index = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuHead, {
    title: "Rekister\xF6idy",
    description: "Rekister\xF6idy Dixuun ja ryhdy Dixuttajaksi. Rekister\xF6itym\xE4ll\xE4 voit aloittaa asunnon myynnin tai tehd\xE4 kohteesta ostotarjouksen vaivattomasti verkossa."
  }), /*#__PURE__*/React.createElement(DixuRegisterFlow, null));
};
export const getServerSideProps = async _ref => {
  let {
    req,
    res,
    query,
    locale
  } = _ref;
  const {
    step
  } = query;
  if (!['2'].includes(step) && getUser({
    req
  })) {
    redirect('/oma-dixu', {
      res
    });
  }
  return {
    props: _objectSpread({}, await serverSideTranslations(locale || req.locale, ['common', 'register']))
  };
};
export default Index;